module.exports = __webpack_public_path__ + "img/logo.5ea57f53.png";